import React from 'react';

export const CustomCircularProgress = ({ className }) => (
  <span
    className={`inline-block  border-4  border-solid  rounded-full animate-spin ${
      className || 'w-10 h-10 border-primary-blue'
    }`}
    style={{ borderTopColor: 'transparent' }}></span>
);
